import React, { useMemo, useEffect } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchFranchiseType } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";

const Franchise = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
  required,
  defaultValue,
}) => {
  const login = useSelector((state) => state.jwtAuthreducer);

  const {
    data: franchiseTypeList,
    isLoading,
    error,
    refetch,
  } = useQuery(["Franchise"], () => fetchFranchiseType({ ...login }), {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  useEffect(() => {
    refetch();
  }, [login]);

  const options = useMemo(() => {
    return (
      franchiseTypeList?.data?.data?.map((ele) => ({
        value: ele.id,
        label: ele.franchise_type,
      })) || []
    );
  }, [franchiseTypeList]);

  const initialFranchiseId = React.useMemo(() => {
    if (rowData?.franchise_obj?.franchise_type) {
      return options.find(
        (opt) => opt.label === rowData.franchise_obj.franchise_type
      )?.value;
    }
    if (rowData?.franchise_type) {
      return options.find(
        (opt) =>
          opt.value === rowData.franchise_type ||
          opt.label === rowData.franchise_type
      )?.value;
    }
    if (defaultValue) {
      return options.find(
        (opt) => opt.value === defaultValue || opt.label === defaultValue
      )?.value;
    }
    return null;
  }, [rowData, defaultValue, options]);

  useEffect(() => {
    if (options.length > 0 && initialFranchiseId) {
      setValue("franchise_type_id", initialFranchiseId);
      const selectedLabel =
        options.find((opt) => opt.value === initialFranchiseId)?.label || "";
      setValue("franchise_type", selectedLabel);
    }
  }, [options, initialFranchiseId, setValue]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Franchise Type</div>;

  return (
    <>
      <Controller
        name="franchise_type_id"
        control={control}
        rules={{
          required: required ? "Franchise is required" : false,
        }}
        render={({ field: { onChange, value } }) => {
          const selectedOption =
            options.find((option) => option.value === value) || null;

          return (
            <Select
              options={options}
              value={selectedOption}
              onChange={(selectedOption) => {
                const newValue = selectedOption ? selectedOption.value : "";
                const newLabel = selectedOption ? selectedOption.label : "";
                onChange(newValue);
                setValue("franchise_type", newLabel);
              }}
              isClearable
              placeholder="Select Franchise Type"
              menuPortalTarget={document.body}
              classNamePrefix="react-select"
              className={`react-select-container ${
                errors.franchise_type_id ? "is-invalid" : ""
              }`}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          );
        }}
      />
      {errors.franchise_type_id && (
        <div className="invalid-feedback">
          {errors.franchise_type_id.message}
        </div>
      )}
    </>
  );
};

export default Franchise;
